<template lang="html">
  <v-dialog :value="showUnauthorizedModal" width="380" persistent>
    <v-card>
      <v-card-title>Log In</v-card-title>
      <v-card-text>
        You are unauthorized to see this page. Please sign up!
      </v-card-text>
      <v-card-actions>
        <v-btn color="accent" @click="">Sign Up</v-btn>
        <v-btn color="accent" @click="back">Back</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import firebase from 'firebase';
import { mapState } from 'vuex';

export default {
  name: 'UnauthorizedModal',
  data: () => ({
  }),
  computed: {
    ...mapState('applications', [
      'showUnauthorizedModal',
    ]),
  },
  methods: {
    back() {
      this.$store.dispatch('applications/hideUnauthorizedModal');
      this.$router.push('/');
    },
  },
}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// src/components/UnauthorizedModal.vue